import React from "react";


import FenceIcon from "@mui/icons-material/Fence";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import WorkIcon from "@mui/icons-material/Work";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";

export const SidebarData = [
  {
    title: "How to use BoQ tool?",
    icon: <BuildCircleIcon />,
    link: " ",
  },
  {
    title: "What are the limitations of the BoQ tool?",
    icon: <FenceIcon />,
    link: " ",
  },
  {
    title: "How to use our predefined designs?",
    icon: <DesignServicesIcon />,
    link: " ",
  },
  {
    title: "How to get services from our proffessionals",
    icon: <MiscellaneousServicesIcon />,
    link: " ",
  },
  {
    title: "What kind of services can we get through proffessionals?",
    icon: <MiscellaneousServicesIcon />,
    link: " ",
  },
  {
    title: "How can I register as a proffession?",
    icon: <WorkIcon />,
    link: " ",
  },
];
 